export default {
  forms: [
    {
      id: "YDF7",
      title: "Induction Checklist"
    }
  ].sort((a, b) => a.title.localeCompare(b.title))
};
